<div
  *ngIf="showLayout"
  [ngClass]="{
    'blank-page': !showLayout,
    'dark-theme': themeService.isDark(),
    'card-borderd-theme': themeService.isCardBorder(),
    'card-border-radius': themeService.isCardBorderRadius(),
    'rtl-enabled': themeService.isRTLEnabled()
  }"
>
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <div
    class="main-content transition d-flex flex-column"
    [ngClass]="{'active': isSidebarToggled}"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
  >
    <app-header></app-header>
    <router-outlet></router-outlet>
    <div class="flex-grow-1"></div>
    <app-footer></app-footer>
  </div>
</div>

<!-- Layout pour les pages SANS sidebar/header/footer -->
<div *ngIf="!showLayout">
  <router-outlet></router-outlet>
</div>
